import script from "./TheCabinet.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCabinet.vue?vue&type=script&setup=true&lang=js"

import "./TheCabinet.vue?vue&type=style&index=0&id=657cfb9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657cfb9e"]])

export default __exports__